import { render, staticRenderFns } from "./AboutCard.vue?vue&type=template&id=1368d838&scoped=true&"
import script from "./AboutCard.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AboutCard.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AboutCard.vue?vue&type=style&index=0&id=1368d838&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1368d838",
  null
  
)

export default component.exports